import { Editor as ToastEditor } from "@toast-ui/react-editor";
import Editor from "components/document/Create/Editor";
import DocumentTextField from "components/foundation/DocumentTextField/DocumentTextField";
import React, { useEffect, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import CreateDocumentForm from "../../CreateDocumentForm";
import CreateDocumentClassFormBody from "../CreateDocumentClassFormBody";
import { TempDocumentDetailResponseWithAny } from "features/document/hooks/queries/useTempDocumentDetailQuery";
import { KSS_FIELD as FIELD } from "config/documentConstant";
import formatMinMaxLengthMessage from "utils/formatUtils/formatMinMaxLengthMessage";

/* KSS */
interface KssForm {
  [FIELD.TITLE.key]: string;
  [FIELD.CONTENT.key]: string;
}

interface KSSProps {
  tempDocumentDetail?: TempDocumentDetailResponseWithAny;
}

const KSS = ({ tempDocumentDetail }: KSSProps) => {
  const {
    register,
    control,
    setValue,
    formState: { errors },
  } = useFormContext<KssForm>();
  const editorRef = useRef<ToastEditor | null>(null);

  useEffect(() => {
    if (editorRef.current && tempDocumentDetail) {
      editorRef.current
        .getInstance()
        .setHTML(tempDocumentDetail.documentData?.[FIELD.CONTENT.key]);
    }
  }, [tempDocumentDetail]);

  useEffect(() => {
    const editorInstance = editorRef.current;

    if (!editorInstance) return;

    const handleChange = () => {
      const value = editorInstance.getInstance().getHTML() || "";
      setValue(FIELD.CONTENT.key, value);
    };

    editorInstance.getInstance().on("change", handleChange);
    return () => editorInstance.getInstance().off("change");
  }, []);

  return (
    <CreateDocumentClassFormBody noBorderTop>
      <CreateDocumentForm.Field label={FIELD.TITLE.label}>
        <DocumentTextField
          {...register(FIELD.TITLE.key, {
            required: "제목 기입 필수",
            minLength: {
              value: FIELD.TITLE.minLength,
              message: formatMinMaxLengthMessage(
                FIELD.TITLE.minLength,
                FIELD.TITLE.maxLength,
              ),
            },
            maxLength: {
              value: FIELD.TITLE.maxLength,
              message: formatMinMaxLengthMessage(
                FIELD.TITLE.minLength,
                FIELD.TITLE.maxLength,
              ),
            },
          })}
          placeholder="제목을 입력해 주세요."
          errorMessage={errors[FIELD.TITLE.key]?.message}
        />
      </CreateDocumentForm.Field>

      <CreateDocumentForm.Field label={FIELD.CONTENT.label}>
        <Controller
          name={FIELD.CONTENT.key}
          control={control}
          rules={{
            required: "내용 기입 필수",
          }}
          render={({ field }) => (
            <Editor
              ref={editorRef}
              placeholder="내용을 입력해 주세요."
              defaultValue={
                tempDocumentDetail?.documentData?.[FIELD.CONTENT.key] ||
                field.value
              }
              errorMessage={errors[FIELD.CONTENT.key]?.message}
            />
          )}
        />
      </CreateDocumentForm.Field>
    </CreateDocumentClassFormBody>
  );
};

export default KSS;
